import { createPersistentStorage } from "@/script/storage/storage-factory"
import { global } from "@/script/helper"

export default createPersistentStorage(
	"tcf.pref",
	{
		lang: "en",
		colorOverrides: {
			//MarkerType: [false, "#FF0000FF"],
		},
	},
	{
		overrideColor(state, [markerType, color]) {
			state.colorOverrides[markerType] = [true, color]
		},
		overrideColorToggle(state, [markerType, newState]) {
			state.colorOverrides[markerType] ??= [newState, "#FFFFFFFF"]
			state.colorOverrides[markerType][0] = newState
		},
	},
	{
		async syncLocale({ state }) {
			global.locale.value = state.lang
		},
	}
)
